import GoogleAnalytics from 'react-ga';

// GoogleAnalytics.initialize(process.env.GA_ID || 'UA-169378714-1', {
// GoogleAnalytics.initialize('UA-169378714-1', {
//     debug: (process.env.NODE_ENV !== 'production'),
//     titleCase: true,
//     sampleRate: (process.env.NODE_ENV === 'production') ? 100 : 0,
//     forceSSL: true
// });

export default GoogleAnalytics;
